const ITEMS = [
  "Cinematic Video Streaming",
  "Native iOS Experience",
  "Creator & Social Feeds",
  "4K HDR Clarity",
  "Real-Time Community",
];

const MarqueeRow = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-heading text-2xl font-bold uppercase tracking-tight text-white/25 sm:text-4xl">
          {item}
        </span>
        <span className="h-2 w-2 shrink-0 rounded-full bg-crimson/70" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section aria-hidden="true" className="overflow-hidden border-y border-white/10 py-7" data-testid="marquee-ribbon">
    <div className="marquee-track flex w-max">
      <MarqueeRow />
      <MarqueeRow />
    </div>
  </section>
);

export default Marquee;
